export default __webpack_public_path__ + "static/media/logo-shopify.98e3f7cf.svg";